export const tutorials = [
    {
        title: "To-go todo",
        div: [
            { title1: "Usage" },
            { content: "After Installation," },
            { content: "on the current page that you're in, right click to access the context menu" },
            { content: "Click on the option 'Add to my to-go todo list', " },
            { image: '/images/ext-001.png' },
            { content: "This will bring up the popup form to enter an item or ', " },
            { image: '/images/ext-form.png' },
            { content: "access the list of already saved items.', " },
            { image: '/images/add-items.png' },

        ],
        file: "/to-go todo.zip"
    }, 
    {
        title: "Word Plus",
        div: [
            { title1: "Usage" },
            { content: "After Installation," },
            { content: "Select a word or phrase in chrome." },
            { content: "Right click to access the context menu then choose the option 'Find meaning...'" },
            { image: '/images/word-plus1.png' },
            { image: '/images/word-plus2.png' }
        ],
        file: "/word-plus.zip"

    }
]